<template>
  <nav ref="menuMobile" :class="{ ativo: state.opcoesMobile }">
    <!-- Logo -->
    <img src="https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/identidade/logo-v1.svg" class="logo" @click="irParaRota('/inicio')" />
    <!-- OpçÕes -->
    <div class="opcoes">
      <button class="opcao" :class="{ ativo: $route.path === '/inicio' }" @click="irParaRota('/inicio')">
        <div class="icone">
          <Svgs nome="cursor" />
        </div>
        <p>Suas áreas de membros</p>
      </button>
      <button class="opcao" :class="{ ativo: $route.path === '/planos' }" @click="irParaRota('/planos')">
        <div class="icone">
          <Svgs nome="estrela" />
        </div>
        <p>Seu plano</p>
        <div class="plano">
          <img :src="`https://central-statics.nyc3.digitaloceanspaces.com/global/planos/${tipoPlanoConvertido || 'free'}.png`" />
          <h4>{{ tipoPlanoConvertido }}</h4>
        </div>
      </button>
    </div>
    <!-- Perfil -->
    <div class="perfil" :class="{ ativo: state.opcoesPerfil }" ref="expandirPerfil">
      <button class="abrir" @click="state.opcoesPerfil = !state.opcoesPerfil">
        <div class="foto" :style="`background-image: url('${storePerfil.usuario?.imagemPerfil || 'https://central-statics.nyc3.digitaloceanspaces.com/unicpages/imagens/app/icones/placeholder-perfil.svg'}')`"></div>
        <span></span>
        <div class="nome">
          <h3>{{ (storePerfil.usuario?.nome || '').split(' ').slice(0, 2).join(' ') }}</h3>
        </div>
        <Svgs nome="setinha" />
      </button>
      <div class="balao">
        <div class="info">
          <p>{{ storePerfil.usuario?.email }}</p>
          <h4>Conta criada {{ exibirData(storePerfil.usuario?.dataRegistro) }}</h4>
        </div>
        <button @click="abrirModal('editarPerfil', 'editar', 'Editar Perfil')">
          <Svgs nome="editar" />
          <p>Editar Perfil</p>
        </button>
        <button @click="abrirModal('alterarSenha', 'cadeado', 'Alterar Senha')">
          <Svgs nome="cadeado" />
          <p>Alterar Senha</p>
        </button>
        <div class="linha"></div>
        <button @click="sair()">
          <Svgs nome="sair" />
          <p>Sair da Plataforma</p>
        </button>
      </div>
    </div>
    <!-- Menu Mobile -->
    <button class="menu" @click="state.opcoesMobile = !state.opcoesMobile">
      <Svgs nome="menu" />
    </button>
    <!-- Modals -->
    <Teleport to="body">
      <ModalEditarPerfil />
      <ModalAlterarSenha />
    </Teleport>
  </nav>
</template>

<script setup>
import { reactive, ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStorePerfil, useStoreModal } from '@stores'
import { helperClicouFora } from '@helpers'
import ModalEditarPerfil from '@components/app/perfil/modals/ModalEditarPerfil.vue'
import ModalAlterarSenha from '@components/app/perfil/modals/ModalAlterarSenha.vue'
import Svgs from '@svgs'

const router = useRouter()
const storePerfil = useStorePerfil()
const storeModal = useStoreModal()
const emitter = inject('emitter')

const expandirPerfil = ref(null)
const menuMobile = ref(null)

const state = reactive({
  opcoesPerfil: false,
  opcoesMobile: false
})

function abrirModal(nome, icone, titulo) {
  storeModal.abrirModal(nome, icone, titulo)
  fecharOpcoes()
}

function exibirData(dataRegistro) {
  const data = new Date(dataRegistro)
  const agora = new Date()
  const diferencaEmMilissegundos = agora - data

  const minutos = Math.floor(diferencaEmMilissegundos / (1000 * 60))
  const horas = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60))
  const dias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24))

  if (minutos < 60) {
    return `há ${minutos} minuto${minutos === 1 ? '' : 's'}`
  } else if (horas < 24) {
    return `há ${horas} hora${horas === 1 ? '' : 's'}`
  } else if (dias < 7) {
    return `há ${dias} dia${dias === 1 ? '' : 's'}`
  } else {
    const dia = data.getDate().toString().padStart(2, '0')
    const mes = (data.getMonth() + 1).toString().padStart(2, '0')
    const ano = data.getFullYear()
    return `em ${dia}/${mes}/${ano}`
  }
}

function sair() {
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Você saiu de sua conta Level' })
  localStorage.removeItem('levelmember-produtor-access-token')
  router.push('/')
}

function fecharOpcoes() {
  state.opcoesPerfil = false
  state.opcoesMobile = false
}

function irParaRota(rota) {
  fecharOpcoes()
  router.push(rota)
}

const tipoPlanoConvertido = computed(() => {
  const tipo = storePerfil.usuario?.assinatura?.plano
  if (!tipo) return 'free'

  const tiposPlano = {
    expert: 'diamond',
    pro: 'gold',
    essencial: 'silver',
    free: 'free'
  }

  return tiposPlano[tipo.toLowerCase()] || 'free'
})

helperClicouFora.clicouFora([
  {
    alvo: expandirPerfil,
    retornoChamada: () => (state.opcoesPerfil = false)
  },
  {
    alvo: menuMobile,
    retornoChamada: () => (state.opcoesMobile = false)
  }
])
</script>

<style scoped>
nav {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  width: 260px;
  max-width: 260px;
  min-width: 260px;
  background-color: var(--cor-preto);
  padding: 20px;
  z-index: 10;
  transition: all 0.3s;
}
img.logo {
  width: 130px;
  margin: 0 0 20px 0;
}
.opcoes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.opcao {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 10px 0;
  transition: all 0.3s;
}
.opcao:hover .icone {
  background-color: var(--cor-escuro-4);
}
.opcao.ativo .icone {
  background-color: var(--cor-marca);
}
.opcao.ativo .icone svg {
  fill: var(--cor-branco);
}
.opcao.ativo p {
  color: var(--cor-branco);
}
.opcao .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 8px;
  background-color: var(--cor-escuro-3);
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
.opcao .icone svg {
  width: 12px;
  min-width: 12px;
  max-height: 12px;
  fill: var(--cor-escuro-6);
  transition: all 0.3s;
}
.opcao p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.opcao .plano {
  display: flex;
  align-items: center;
  background-color: var(--cor-escuro-3);
  border-radius: 50px;
  padding: 2px 5px;
  margin: 0 0 0 5px;
}
.opcao .plano img {
  width: 10px;
  max-height: 10px;
  margin: 0 5px 0 0;
}
.opcao .plano h4 {
  font-family: var(--medium);
  font-size: var(--f0);
  color: var(--cor-branco);
  text-transform: capitalize;
}
.perfil {
  display: flex;
  position: relative;
  width: 100%;
  margin-top: auto;
}
.perfil .abrir {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  background-color: transparent;
  width: 100%;
  padding: 20px 0 0 0;
  border-top: 1px solid var(--cor-escuro-3);
}
.perfil .abrir:hover span {
  background-color: var(--cor-branco);
}
.perfil .abrir .foto {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--cor-escuro-3);
  background-size: cover;
  background-position: center;
}
.perfil .abrir span {
  width: 14px;
  height: 14px;
  background-color: var(--cor-marca);
  border: 2px solid var(--cor-preto);
  border-radius: 50%;
  position: absolute;
  top: 15px;
  left: 25px;
  transition: all 0.3s;
}
.perfil .abrir .nome h3 {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 0 0 0 15px;
}
.perfil .abrir svg {
  position: absolute;
  right: 0;
  width: 15px;
  min-width: 15px;
  fill: var(--cor-escuro-4);
  transform: rotate(-90deg);
}
.perfil .balao {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: var(--cor-preto);
  border: 2px solid var(--cor-escuro-3);
  padding: 15px 20px;
  border-radius: 8px;
  position: absolute;
  bottom: -15px;
  left: 250px;
  width: 220px;
  min-width: 220px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.perfil.ativo .balao {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.perfil .balao .linha {
  width: 100%;
  height: 2px;
  background-color: var(--cor-escuro-3);
  margin: 10px 0;
}
.perfil .balao button {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 10px 0;
  transition: all 0.3s;
}
.perfil .balao button:hover {
  opacity: 0.7;
}
.perfil .balao button svg {
  width: 12px;
  min-width: 12px;
  max-height: 12px;
  fill: var(--cor-escuro-6);
  margin: 0 10px 0 0;
}
.perfil .balao button p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
}
.perfil .balao button:nth-last-child(1) p {
  color: var(--cor-vermelho);
}
.perfil .balao button:nth-last-child(1) svg {
  fill: var(--cor-vermelho);
}
.perfil .balao .info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.perfil .balao .info p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
}
.perfil .balao .info h4 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  margin: 5px 0 10px 0;
  width: 100%;
}
.menu {
  display: none;
  background-color: transparent;
  position: absolute;
  top: 15px;
  right: 20px;
}
.menu svg {
  width: 20px;
  min-height: 20px;
  fill: var(--cor-branco);
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    height: 45px;
    min-height: 45px;
    max-height: 45px;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    padding: 15px 20px;
    overflow: hidden;
    z-index: 10;
  }
  img.logo {
    width: 100px;
    margin: 0;
  }
  nav.ativo {
    height: 100dvh;
    max-height: 100dvh;
    min-height: 100dvh;
  }
  .opcoes {
    margin: 10px 0 0 0;
  }
  .opcoes .opcao {
    padding: 5px 0;
  }
  .opcoes .opcao .icone {
    width: 25px;
    height: 25px;
  }
  .perfil {
    flex-direction: column;
    width: 100%;
    margin-top: 0;
    margin: 20px 0 0 0;
  }
  .perfil .abrir svg {
    display: none;
  }
  .perfil .balao {
    padding: 15px 20px;
    border-radius: 8px;
    position: relative;
    bottom: auto;
    left: auto;
    width: 100%;
    min-width: 100%;
    margin: 20px 0 0 0;
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }
  .menu {
    display: flex;
  }
}
</style>
